(function () {

  function showToast(message) {
    var existing = document.querySelector('.addon-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'addon-toast';
    toast.textContent = message;
    toast.style.opacity = '0';
    toast.style.transition = 'opacity 0.2s ease';
    document.body.appendChild(toast);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { toast.style.opacity = '1'; });
    });
    setTimeout(function () {
      toast.style.opacity = '0';
      setTimeout(function () { if (toast.parentNode) toast.remove(); }, 200);
    }, 2500);
  }

  function updateCartCount(count) {
    document.querySelectorAll('cart-count.header__cart-count').forEach(function (el) {
      el.textContent = count;
    });
    document.querySelectorAll('.bubble-count').forEach(function (el) {
      el.textContent = count;
    });
  }

  function refreshCartOnce() {
    setTimeout(function () {
      fetch('/?sections=mini-cart')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data['mini-cart']) return;
          var temp = document.createElement('div');
          temp.innerHTML = data['mini-cart'];
          var newDrawer = temp.querySelector('cart-drawer');
          var cartDrawer = document.querySelector('cart-drawer');
          if (newDrawer && cartDrawer) {
            cartDrawer.innerHTML = newDrawer.innerHTML;
          }
        })
        .catch(function () {});

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { updateCartCount(cart.item_count); })
        .catch(function () {});
    }, 800);
  }

  var previewEl = null;

  function getPreview() {
    if (!previewEl) {
      previewEl = document.createElement('div');
      previewEl.className = 'addon-img-preview';
      previewEl.innerHTML = '<img src="" alt="">';
      document.body.appendChild(previewEl);
    }
    return previewEl;
  }

  var lightboxEl = null;

  function getLightbox() {
    if (!lightboxEl) {
      lightboxEl = document.createElement('div');
      lightboxEl.className = 'addon-lightbox';
      lightboxEl.innerHTML =
        '<div class="addon-lightbox__inner">' +
          '<img src="" alt="" class="addon-lightbox__img">' +
          '<button class="addon-lightbox__close">×</button>' +
        '</div>';
      document.body.appendChild(lightboxEl);
      lightboxEl.querySelector('.addon-lightbox__close').addEventListener('click', function () {
        lightboxEl.classList.remove('addon-lightbox--open');
      });
      lightboxEl.addEventListener('click', function (e) {
        if (e.target === lightboxEl) lightboxEl.classList.remove('addon-lightbox--open');
      });
    }
    return lightboxEl;
  }

  function bindImageInteraction(imgWrap, imgState) {
    if (window.innerWidth > 768) {
      var preview = getPreview();
      var previewImg = preview.querySelector('img');
      imgWrap.addEventListener('mouseenter', function () {
        if (!imgState.large) return;
        previewImg.src = imgState.large;
        preview.classList.add('addon-img-preview--visible');
      });
      imgWrap.addEventListener('mousemove', function (e) {
        preview.style.left = (e.clientX + 20) + 'px';
        preview.style.top = Math.max(10, e.clientY - 160) + 'px';
      });
      imgWrap.addEventListener('mouseleave', function () {
        preview.classList.remove('addon-img-preview--visible');
      });
    } else {
      imgWrap.style.cursor = 'zoom-in';
      imgWrap.addEventListener('click', function () {
        if (!imgState.large) return;
        var lb = getLightbox();
        lb.querySelector('.addon-lightbox__img').src = imgState.large;
        lb.classList.add('addon-lightbox--open');
      });
    }
  }

  function shopifyImageUrl(src, size) {
    if (!src) return src;
    return src.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_' + size + '$1');
  }

  function doAtc(variantId, btn, addedText) {
    var originalHtml = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '...';

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

    xhr.onload = function () {
      if (xhr.status === 200) {
        btn.innerHTML = '<span style="color:#ff6b00;font-size:1.2em;">✓</span>';
        showToast('✓ ' + addedText);
        refreshCartOnce();
        setTimeout(function () {
          btn.innerHTML = originalHtml;
          btn.disabled = false;
        }, 3000);
      } else {
        console.warn('[addon] add failed status:', xhr.status);
        btn.innerHTML = originalHtml;
        btn.disabled = false;
      }
    };

    xhr.onerror = function () {
      console.warn('[addon] add failed network error');
      btn.innerHTML = originalHtml;
      btn.disabled = false;
    };

    xhr.send(JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }));
  }

  function renderItems(products, oosText, atcText, addedText) {
    var list = document.getElementById('addon-list');
    if (!list) return;
    list.innerHTML = '';
    if (!products.length) return;

    products.forEach(function (item) {
      var card = document.createElement('div');
      card.className = 'addon-card' + (item.available ? '' : ' addon-card--oos');

      var imgState = {
        small: item.image || '',
        large: item.image_large || ''
      };

      var imgHtml = '';
      if (item.image) {
        imgHtml =
          '<div class="addon-card__img-wrap">' +
            '<img src="' + item.image + '" alt="' + item.title.replace(/"/g, '&quot;') + '" class="addon-card__img" width="72" height="72">' +
          '</div>';
      }

      var multiVariant = item.variants.length > 1;
      var selectHtml = '';
      if (multiVariant) {
        selectHtml = '<select class="addon-card__select">';
        item.variants.forEach(function (v) {
          var dis = v.available ? '' : ' disabled';
          var suffix = v.available ? '' : ' — ' + oosText;
          selectHtml += '<option value="' + v.id + '"' + dis + '>' + v.title + suffix + '</option>';
        });
        selectHtml += '</select>';
      }

      var firstVariantId = item.variants[0] ? item.variants[0].id : '';
      var btnHtml = item.available
        ? '<button class="addon-card__atc button button--primary button--full">' + atcText + '</button>'
        : '<button class="addon-card__atc button button--primary button--full addon-card__atc--oos" disabled>' + oosText + '</button>';

      card.innerHTML =
        '<div class="addon-card__header">' +
          imgHtml +
          '<div class="addon-card__info">' +
            '<a href="' + item.url + '" class="addon-card__title" target="_blank">' + item.title + '</a>' +
            '<span class="addon-card__price">' + item.price_min_formatted + '</span>' +
          '</div>' +
        '</div>' +
        (multiVariant ? selectHtml : '') +
        '<div class="addon-card__action">' + btnHtml + '</div>';

      var imgWrap = card.querySelector('.addon-card__img-wrap');
      if (imgWrap) {
        bindImageInteraction(imgWrap, imgState);
      }

      var btn = card.querySelector('.addon-card__atc');
      if (btn && item.available) {
        var select = card.querySelector('.addon-card__select');

        btn.addEventListener('click', function () {
          var variantId = select ? Number(select.value) : firstVariantId;
          if (!variantId) return;
          doAtc(variantId, btn, addedText);
        });

        if (select) {
          select.addEventListener('change', function () {
            var chosen = item.variants.find(function (v) { return String(v.id) === select.value; });
            if (!chosen) return;

            if (chosen.featured_image && chosen.featured_image.src) {
              var newSmall = shopifyImageUrl(chosen.featured_image.src, '120x120');
              var newLarge = shopifyImageUrl(chosen.featured_image.src, '600x600');
              var cardImg = card.querySelector('.addon-card__img');
              if (cardImg) cardImg.src = newSmall;
              imgState.small = newSmall;
              imgState.large = newLarge;
            }

            if (chosen.available) {
              btn.disabled = false;
              btn.classList.remove('addon-card__atc--oos');
              btn.innerHTML = atcText;
            } else {
              btn.disabled = true;
              btn.classList.add('addon-card__atc--oos');
              btn.innerHTML = oosText;
            }
          });
        }
      }

      list.appendChild(card);
    });
  }

  function initFilter(block, allProducts, oosText, atcText, addedText) {
    var makeSelect = block.querySelector('#addon-make-select');
    var modelSelect = block.querySelector('#addon-model-select');
    if (!makeSelect || !modelSelect) return;

    var modelPlaceholder = block.dataset.modelPlaceholder || '— Model —';
    var makeModelMap = {};

    allProducts.forEach(function (item) {
      var tags = (item.tags || []).map(function (t) { return t.trim().toLowerCase(); });
      var makes = tags.filter(function (t) { return t.startsWith('fit-make:'); }).map(function (t) { return t.slice(9); });
      var models = tags.filter(function (t) { return t.startsWith('fit-model:'); }).map(function (t) { return t.slice(10); });
      makes.forEach(function (make) {
        if (!makeModelMap[make]) makeModelMap[make] = new Set();
        models.forEach(function (model) {
          if (model.startsWith(make + '-')) makeModelMap[make].add(model);
        });
      });
    });

    Object.keys(makeModelMap).sort().forEach(function (make) {
      var opt = document.createElement('option');
      opt.value = make;
      opt.textContent = make.toUpperCase();
      makeSelect.appendChild(opt);
    });

    makeSelect.addEventListener('change', function () {
      var selectedMake = makeSelect.value;
      modelSelect.innerHTML = '<option value="">' + modelPlaceholder + '</option>';
      document.getElementById('addon-list').innerHTML = '';
      if (!selectedMake) { modelSelect.disabled = true; return; }

      var models = Array.from(makeModelMap[selectedMake] || []).sort();
      models.forEach(function (model) {
        var opt = document.createElement('option');
        opt.value = model;
        opt.textContent = model.replace(selectedMake + '-', '').replace(/-/g, ' ').toUpperCase();
        modelSelect.appendChild(opt);
      });
      modelSelect.disabled = models.length === 0;
    });

    modelSelect.addEventListener('change', function () {
      var selectedMake = makeSelect.value;
      var selectedModel = modelSelect.value;
      if (!selectedMake || !selectedModel) {
        document.getElementById('addon-list').innerHTML = '';
        return;
      }
      var matched = allProducts.filter(function (item) {
        var tags = (item.tags || []).map(function (t) { return t.trim().toLowerCase(); });
        return tags.indexOf('fit-make:' + selectedMake) > -1 &&
               tags.indexOf('fit-model:' + selectedModel) > -1;
      });
      renderItems(matched, oosText, atcText, addedText);
    });
  }

  function init() {
    var block = document.getElementById('product-addon-checkboxes');
    if (!block) return;

    var dataEl = document.getElementById('addon-products-data');
    if (!dataEl) return;

    var allProducts = [];
    try { allProducts = JSON.parse(dataEl.textContent); } catch (e) {
      console.warn('[addon] parse error', e); return;
    }

    var addedText = block.dataset.added || 'Added to cart';
    var oosText   = block.dataset.oos   || 'Out of Stock';
    var atcText   = block.dataset.atc   || 'Add to Cart';

    initFilter(block, allProducts, oosText, atcText, addedText);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
